import { combineReducers } from "redux";
import { themeMode } from "./ThemeMode";
import { snackBar } from "./SnackBar";
import { state } from "./State";
import { cart } from "./Cart";

export const rootReducer = combineReducers({
  themeMode,
  state,
  snackBar,
  cart,
});
